module.exports = __webpack_public_path__ + "static/7-c4fc96afd2ad5d2cb732bdc9a599d3ac.png";